import ReactDOM from 'react-dom/client';
import Main from 'Main';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Main />
  </>
);
